module.exports = {
    PERSONALITY_OLD: 33,
    PERSONALITY_HEXACO: 39,
    PERSONALITY: 41,
    INTERESTS: 32,
    WORKPLACE: 14,
    VALUES: 31,
    PURPOSE_SURVEY: 42,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/assessments.js
// module id = 172
// module chunks = 58